//#region src/lib/safe-number.ts
const stripSeparators = (s) => s.replace(/(_|,)/g, "");
function isDecimal(s) {
	const v = typeof s === "string" ? Number.parseInt(s) : s;
	if (Number.isNaN(v)) throw new Error(`${s} isNaN`);
	if (typeof s === "number") return /\./g.test(s.toPrecision(10));
	else return /\./g.test(s);
}
function toN(s) {
	if (typeof s === "string") {
		const normalize = stripSeparators(s).valueOf();
		return isDecimal(normalize) ? Number.parseFloat(normalize) : Number.parseInt(normalize);
	}
	return s;
}
function n(s) {
	const toP = typeof s === "number" ? s.toPrecision(10) : s;
	return stripSeparators(toN(toP.valueOf()).toPrecision(10));
}
//#endregion
export { isDecimal, n, stripSeparators, toN };
